import map_mobile from "assets/map-mobile.svg";
import map from "assets/map.svg";
import mapbase from "assets/map/base.png";
import { ReactComponent as CanadaIcon } from "assets/map/canada.svg";
import { ReactComponent as GhanaIcon } from "assets/map/ghana.svg";
import { ReactComponent as IvoryCoastIcon } from "assets/map/ivory-coast.svg";
import { ReactComponent as KenyaIcon } from "assets/map/kenya.svg";
import { ReactComponent as NigeriaIcon } from "assets/map/nigeria.svg";
import { ReactComponent as USIcon } from "assets/map/us.svg";
import ArcBackground from "assets/arc-background.png";

import MapIcon from "assets/map-icon.svg";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { Link } from "react-router-dom";
import { useGetStartedContext } from "context/GetStartedContextProvider";

const Map = () => {
  const { t } = useTranslation("home");

  const { handleModalChange } = useGetStartedContext();

  const countries = [
    {
      Icon: CanadaIcon,
      top: "5%",
      left: "8%",
      name: "Canada",
      info: "41 Grand court Drive Ottawa, Canada.",
    },
    {
      Icon: USIcon,
      top: "33%",
      left: "7%",
      name: "USA",
      info: "252, Little Falls Drive, Wilmington, Newcastle County, Delaware, USA",
    },
    {
      Icon: GhanaIcon,
      top: "30%",
      left: "40%",
      name: "Ghana",
      info: "West Africa Office",
    },
    {
      Icon: NigeriaIcon,
      top: "45%",
      left: "36%",
      name: "Nigeria",
      info: "The Bunker Building 279 Herbert Macaulay Way Yaba Lagos, Nigeria.",
    },
    {
      Icon: IvoryCoastIcon,
      top: "41%",
      left: "47%",
      name: "Ivory Coast",
      info: "Branch Office",
    },
    {
      Icon: KenyaIcon,
      top: "58%",
      left: "47%",
      name: "Kenya",
      info: "Divine Office Suites Adjacent to ACK St.Mark's Waiyaki Way, Westlands. Nairobi, Kenya",
    },
  ];

  return (
    <section className="relative overflow-hidden pt-0 pb-20 max-lg:pb-14 max-md:pb-16 font-lexend">
      <div className="relative z-10">
        <div
          className="w-full h-[840px]  relative bg-cover bg-center flex items-center justify-center flex-col gap-10"
          style={{ backgroundImage: `url(${ArcBackground})` }}
        >
          <div className="flex justify-center items-center flex-col gap-2">
            <h3 className="text-black font-normal max-md:text-[28px] md:w-[70%] xl:w-[65%] md:text-4xl lg:text-5xl text-center mb-4 font-lexend !leading-[62px]">
              {t("section5.title")}
            </h3>
            <p className="text-black text-center text-sm sm:w-[50%] md:w-[65%] xl:w-[60%] capitalize">
              {t("section5.subtitle")}
            </p>
          </div>

          <div className="flex justify-center items-center flex-col md:flex-row gap-5">
            <Button
              type="button"
              text={t("button.demo")}
              className="!px-10"
              size="sm"
              onClick={() => handleModalChange(true)}
            />
            <Link
              to="https://youtu.be/zjsAvAInW9Q?si=XHcznbIUBvLR1Yqy"
              target="_blank"
            >
              <Button
                variant={"outlined"}
                text={t("learnMoreAbout")}
                className="!px-10"
                size="sm"
              />
            </Link>
          </div>
        </div>

        <div className="w-full relative hidden lg:block px-14 max-md:px-8 max-[520px]:px-4 mt-[-10rem]">
          <img src={mapbase} alt="map" className="w-full" />

          {countries.map((country, idx) => (
            <div
              key={idx}
              className="group shrink-0 w-[30.67px] h-[44.53px] absolute bg-cover bg-center flex justify-center items-start pt-1 cursor-pointer"
              style={{
                top: country.top,
                left: country.left,
                backgroundImage: `url(${MapIcon})`,
              }}
            >
              <country.Icon className="w-6 h-6 z-10" />

              <div
                className="absolute bottom-full mb-2 flex flex-col justify-center items-center 
                bg-[#202D66] w-[250px] min-h-[150px] rounded-md text-white text-xs px-3 py-2 
                shadow-lg z-20 left-1/2 -translate-x-1/2
                opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100
                transition-all duration-300 ease-out pointer-events-none group-hover:pointer-events-auto"
              >
                <h1 className="border-b border-white text-base font-normal mb-2 w-fit text-center">
                  {country.name}
                </h1>
                <p className="text-[#FFFFFFB2] font-normal text-sm break-words text-center leading-[20px]">
                  {country.info}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Tablet map */}
        <img
          src={map}
          alt="map"
          className="w-full hidden md:block lg:hidden px-14 max-md:px-8 max-[520px]:px-4"
        />

        {/* Mobile map */}
        <img
          src={map_mobile}
          alt="map"
          className="w-full md:hidden max-md:block"
        />
      </div>
    </section>
  );
};

export default Map;
